import { Component, OnInit, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CustomFields } from '../../../../api/model/customFields';

export enum InputType {
  TEXT = 'text',
  PASSWORD = 'password',
  DATE = 'date',
  CHECKBOX = 'checkbox',
  PARAGRAPH = 'paragraph',
  LABEL = 'label'
}

@Component({
  selector: 'app-dialog-custom-fields',
  templateUrl: './dialog-custom-fields.component.html',
  styleUrls: ['./dialog-custom-fields.component.scss']
})
export class DialogCustomFieldsComponent implements OnInit {
  form: FormGroup = new FormGroup({});
  InputType = InputType;

  constructor(
    @Inject(MAT_DIALOG_DATA) public customFields: CustomFields[],
    private readonly dialogRef: MatDialogRef<DialogCustomFieldsComponent>
    ) { }

  ngOnInit(): void {
    this.customFields.sort((a, b) => a.order - b.order);
    this.createForm();
  }

  createForm(): void {
    for (const customField of this.customFields) {
      const validators = this.getValidators(customField);
      this.form.addControl(customField.key, new FormControl('', validators));
    }
  }

  getValidators(customField: CustomFields): any[] {
    if (customField.type === InputType.CHECKBOX) {
      return customField.required ? [Validators.requiredTrue] : [];
    } else {
      return customField.required ? [Validators.required] : [];
    }
  }

  setInputValue(value: string | boolean | Date, key: string) {
    this.form.patchValue({ [key]: value })
  }

  closeModal(): void {
    this.dialogRef.close({ result: false });
  }

  onSubmit(): void {
    const customFields = Object.entries(this.form.value).map(([key, value]) => ({
      key, value
    }))

    this.dialogRef.close({ result: true, customFields });
  }

}
